import React, { useState, useEffect } from 'react';
import { HomeURL } from '../services/Webservice';
import { FaTrash, FaSearch, FaEdit, FaPlus, FaTimes, FaImage } from 'react-icons/fa';
import './News.css'; // ?? ??? ????????? ?? ???????????

function News() {
    const [newsList, setNewsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [editingNews, setEditingNews] = useState(null);

    // Initial state for News fields
    const [formData, setFormData] = useState({
        Title: '',
        Description: '',
        Image: '',
        Status: 1
    });

    useEffect(() => { fetchNews(); }, []);

    const fetchNews = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${HomeURL}api/Admin/Get_News`);
            const data = await response.json();
            if (Array.isArray(data)) setNewsList(data);
        } catch (error) {
            console.error('News Fetch Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const formatDateBox = (dateString) => {
        if (!dateString) return <span className="no-date">N/A</span>;
        const dateObj = new Date(dateString);
        const day = dateObj.getDate();
        const month = dateObj.toLocaleString('en-US', { month: 'short' }).toUpperCase();
        const year = dateObj.getFullYear();

        return (
            <div className="date-display-box">
                <span className="date-day">{day}</span>
                <div className="date-month-year">
                    <span className="date-month">{month}</span>
                    <span className="date-year">{year}</span>
                </div>
            </div>
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Flag: 1 for Add, 2 for Update
        const flag = editingNews ? '2' : '1';

        const xmlData = JSON.stringify([{
            NewsId: editingNews ? editingNews.NewsId : 0,
            Title: formData.Title,
            Description: formData.Description,
            Image: formData.Image,
            Status: 1
        }]);

        try {
            const fd = new FormData();
            fd.append('Xml', xmlData);
            fd.append('Flag', flag);

            const response = await fetch(`${HomeURL}api/Admin/Add_Update_del_News`, {
                method: 'POST',
                body: fd
            });

            const resText = await response.text();

            if (resText.includes("SUCCESS")) {
                alert(editingNews ? 'News Updated!' : 'News Added!');
                setShowModal(false);
                setEditingNews(null);
                fetchNews();
            } else {
                alert("Server: " + resText);
            }
        } catch (error) {
            console.error(error);
            alert('Failed to save');
        }
    };

    const handleDelete = async (news) => {
        if (!window.confirm(`Delete News: ${news.Title}?`)) return;
        try {
            const fd = new FormData();
            fd.append('Xml', JSON.stringify([{ NewsId: news.NewsId }]));
            fd.append('Flag', '3'); // Flag 3 for Delete
            const response = await fetch(`${HomeURL}api/Admin/Add_Update_del_News`, {
                method: 'POST',
                body: fd
            });
            const resText = await response.text();
            if (resText.includes("SUCCESS")) fetchNews();
        } catch (error) {
            alert('Delete failed');
        }
    };

    const filteredNews = newsList.filter(n =>
        n.Title?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="lab-tests-container">
            <div className="header-flex">
                <div className="welcome-section">
                    <h1>News Management</h1>
                    <p>Create and manage news articles</p>
                </div>
                <button className="add-btn-main" onClick={() => {
                    setEditingNews(null);
                    setFormData({ Title: '', Description: '', Image: '', Status: 1 });
                    setShowModal(true);
                }}>
                    <FaPlus /> Add News
                </button>
            </div>

            <div className="table-card">
                <div className="search-wrapper">
                    <FaSearch className="search-icon-inside" />
                    <input type="text" placeholder="Search News..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>

                <div className="table-responsive">
                    <table className="employee-style-table">
                        <thead>
                            <tr>
                                <th className="sticky-col">Actions</th>
                                {/*<th>Image</th>*/}
                                <th>Title</th>
                                <th>Description</th>
                                <th>Created Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="5" className="loading-state">Loading News...</td></tr>
                            ) : (
                                filteredNews.map((news) => (
                                    <tr key={news.NewsId}>
                                        <td className="sticky-col">
                                            <div className="action-btns-flex">
                                                <button className="edit-icon-btn" onClick={() => {
                                                    setEditingNews(news);
                                                    setFormData(news);
                                                    setShowModal(true);
                                                }}><FaEdit /></button>
                                                <button className="delete-icon-btn" onClick={() => handleDelete(news)}><FaTrash /></button>
                                            </div>
                                        </td>
                                        {/*<td>*/}
                                        {/*    <img*/}
                                        {/*        src={`${HomeURL}${news.Image}`}*/}
                                        {/*        alt="News"*/}
                                        {/*        style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }}*/}
                                        {/*        onError={(e) => { e.target.src = 'https://via.placeholder.com/50'; }}*/}
                                        {/*    />*/}
                                        {/*</td>*/}
                                        <td><b>{news.Title}</b></td>
                                        <td>
                                            <div style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {news.Description}
                                            </div>
                                        </td>
                                        <td>{formatDateBox(news.CreatedDate)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content small-modal" style={{ maxWidth: '600px' }}>
                        <div className="modal-header">
                            <h2>{editingNews ? 'Update' : 'Add'} News</h2>
                            <FaTimes onClick={() => setShowModal(false)} className="close-x" />
                        </div>
                        <form onSubmit={handleSubmit} className="modal-body-scrollable">
                            <div className="input-box">
                                <label>News Title</label>
                                <input
                                    required
                                    value={formData.Title}
                                    onChange={(e) => setFormData({ ...formData, Title: e.target.value })}
                                />
                            </div>
                            {/*<div className="input-box">*/}
                            {/*    <label>Image Path/URL</label>*/}
                            {/*    <input*/}
                            {/*        placeholder="/Images/News/sample.jpg"*/}
                            {/*        value={formData.Image}*/}
                            {/*        onChange={(e) => setFormData({ ...formData, Image: e.target.value })}*/}
                            {/*    />*/}
                            {/*</div>*/}
                            <div className="input-box">
                                <label>Description</label>
                                <textarea
                                    required
                                    rows="5"
                                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}
                                    value={formData.Description}
                                    onChange={(e) => setFormData({ ...formData, Description: e.target.value })}
                                />
                            </div>
                            <button type="submit" className="save-btn">
                                {editingNews ? 'Update News' : 'Save News'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default News;